<template>
    <LoadingCard v-if="loading" />
    <div v-else>
        <div class="toolbar">
            <div class="toolbar__label">
                Contractors available to be assigned to blocks
            </div>
            <div class="actions">
                <i class="actions__item zmdi zmdi-search" @click="enableSearch"></i>
            </div>

            <div class="toolbar__search" :class="searchEnabled ? 'd-block' : 'd-none'">
                <input type="text" placeholder="Search..." ref="searchInput" v-model="searchTerm">
                <i class="toolbar__search__close zmdi zmdi-long-arrow-left" @click="disableSearch"></i>
            </div>
        </div>

        <div class="card">
            <div class="card-header bg-primary text-white">
                Contractors
            </div>
            <b-table small hover stacked="md" :items="filteredData" :fields="table.fields" sort-by="name" :show-empty="true">
                <template slot="name" slot-scope="row">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input"
                               :id="`contractor${row.item.id}`" type="checkbox"
                               :checked="row.item.is_linked"
                               @click.prevent="toggleRow(row.item)">
                        <label class="custom-control-label" :for="`contractor${row.item.id}`">{{ row.item.name }}</label>
                    </div>
                </template>
                <template slot="region" slot-scope="row">
                    <span class="badge badge-success" v-if="row.item.region.id === currentUser.region.id">{{ row.item.region.name }}</span>
                    <span class="badge badge-warning" v-else>{{ row.item.region.name }}</span>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>
import createLinkMutation from '@views/Setup/ContractorManager/mutationCreateGrowerContractorLink.graphql';
import deleteLinkMutation from '@views/Setup/ContractorManager/mutationDeleteGrowerContractorLink.graphql';
import listAllUsersQuery from '@views/Setup/ContractorManager/queryListAllUsers.graphql';
import listLinkedContractorsQuery from '@views/Setup/ContractorManager/queryListGrowerLinkedContractors.graphql';

/**
 * @property {String} searchTerm
 */
export default {
  name: 'ContractorManager',
  props: ['currentUser'],
  apollo: {
    allContractors: {
      query: listAllUsersQuery,
      update: data => data.filterUsers.data,
      variables: {
        input: {
          role: 'contractor',
        },
      },
    },
    linkedContractors: {
      query: listLinkedContractorsQuery,
      update: data => data.filterGrowerContractorLinks,
    },
  },
  data() {
    return {
      allContractors: [],
      linkedContractors: [],
      searchEnabled: false,
      searchTerm: '',
      inviteEnabled: false,
      inviteLoading: false,
      emailAddress: '',
      loading: 0,
    };
  },
  computed: {
    table() {
      return {
        fields: [
          { key: 'name', label: 'Contractor', sortable: true },
          { key: 'business_name', label: 'Business', sortable: true },
          { key: 'email', label: 'Email' },
          // { key: 'region', label: 'Region' },
        ],
      };
    },
    filteredData() {
      const subjectMatchesSearch = subject => {
        return (
          this.searchTerm.length === 0 ||
          subject.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          subject.email.toLowerCase().includes(this.searchTerm.toLowerCase())
        );
      };

      return this.allContractors
        .filter(contractor => contractor.region.id === this.currentUser.region.id)
        .map(contractor => ({ ...contractor, is_linked: this.linkedContractors.findIndex(linked => linked.id === contractor.id) !== -1 }))
        .filter(subjectMatchesSearch)
        .sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  mounted() {
  },
  methods: {
    enableSearch() {
      this.searchEnabled = true;
      this.$nextTick(() => this.$refs.searchInput.focus());
    },
    disableSearch() {
      this.searchTerm = '';
      this.searchEnabled = false;
    },

    toggleRow(contractor) {
      if (contractor.is_linked) {
        this.unlinkContractor(contractor);
      } else {
        this.linkContractor(contractor);
      }
    },
    unlinkContractor(contractor) {
      this.$apollo.mutate({
        mutation: deleteLinkMutation,
        variables: { input: { contractor_id: contractor.id } },
        update: (store, { data: { deleteGrowerContractorLink: removedLink } }) => {
          const data = store.readQuery({ query: listLinkedContractorsQuery });
          const indexToRemove = data.filterGrowerContractorLinks.findIndex(item => item.id === removedLink.id);
          if (indexToRemove !== -1) {
            data.filterGrowerContractorLinks.splice(indexToRemove, 1);
            store.writeQuery({ query: listLinkedContractorsQuery, data });
          }
        },
        optimisticResponse: {
          __typename: 'Mutation',
          deleteGrowerContractorLink: {
            __typename: 'User',
            id: contractor.id
          },
        },
      });
    },
    linkContractor(contractor) {
      this.$apollo.mutate({
        mutation: createLinkMutation,
        variables: { input: { contractor_id: contractor.id } },
        update: (store, { data: { createGrowerContractorLink: link } }) => {
          const data = store.readQuery({ query: listLinkedContractorsQuery });
          data.filterGrowerContractorLinks.push(link);
          store.writeQuery({ query: listLinkedContractorsQuery, data });
        },
        optimisticResponse: {
          __typename: 'Mutation',
          createGrowerContractorLink: {
            __typename: 'User',
            id: contractor.id,
          },
        },
      });
    },
  },
};
</script>
